<span class="usertag pr-1 pl-1" [ngStyle]="{'background-color': color}">{{ code }}</span>
